'use strict';

const selectTokens = (theme) => ({
    selectSimpleOptionPaddingY: theme.space.component.y.s,
    selectSimpleOptionPaddingX: theme.space.component.x.m,
    selectSimpleOptionHoverBackgroundColor: theme.colors.border,
    selectSimpleOptionFocusBackgroundColor: theme.colors.primary.alpha,
    selectSimpleRadioPaddingX: theme.space.component.x.xs,
    selectSimpleCheckboxPaddingX: theme.space.component.x.xs,
});

exports.selectTokens = selectTokens;
//# sourceMappingURL=select.js.map
